<div cdkDrag cdkDragRootElement=".cdk-overlay-pane">
<h2 mat-dialog-title cdkDragHandle>{{ dialogTitle }}</h2>

<mat-dialog-content>
  <form [formGroup]="organizationForm">
    <mat-form-field appearance="fill" class="org-select-field">
      <mat-label>Select Organization</mat-label>
      <mat-select formControlName="organization">
        <mat-option *ngFor="let org of organizations" [value]="org.organizationId">
          {{ org.organizationName }}
        </mat-option>
      </mat-select>
      <mat-error *ngIf="organizationForm.get('organization').hasError('required')">
        Organization is required.
      </mat-error>
    </mat-form-field>
  </form>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-button color="primary" (click)="onSave()" [disabled]="organizationForm.invalid">Open</button>
  <!-- Conditionally show Close button if moduleType is not undefined -->
  <button *ngIf="moduleType !== undefined" mat-button (click)="onCancel()">Cancel</button>
</mat-dialog-actions>
</div>